(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DragAndDrop", [], factory);
	else if(typeof exports === 'object')
		exports["DragAndDrop"] = factory();
	else
		root["DragAndDrop"] = factory();
})(this, function() {
return 